
export default {
  props: {
    fill: {
      type: String,
      default: "#FF4235",
    },
  },
};
